import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import React, { useCallback, useRef } from 'react'
import MerchandiseSearchDropdownInput from './MerchandiseSearchDropdownInput'
import { formToObject } from 'lib/forms/formToObject'
import { useAppDispatch } from 'hooks/reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'
import qs from 'qs'

interface Props {
  onInputClick?: React.MouseEventHandler<HTMLInputElement>;
}

function MerchandiseSearchForm(props: Props) {
  const { onInputClick } = props
  const containerRef = useRef<HTMLFormElement>(null)
  const dispatch = useAppDispatch()
  const onSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = formToObject<{ search: string }>(e.currentTarget)
    const text = formData.search || undefined

    dispatch(pushWithRegion('/search/shop', qs.stringify({ search: text })))
  }, [dispatch])

  return <form onSubmit={onSubmit} ref={containerRef}>
    <Group direction="horizontal" gap={16} verticalAlign="center">
      <MerchandiseSearchDropdownInput
        anchorRef={containerRef}
        onClick={onInputClick}
      />
      <TextButton kind="primary" size="large" type="submit">
        Search
      </TextButton>
    </Group>
  </form>
}

export default MerchandiseSearchForm
